export default "__VITE_ASSET__TJhANbme__"